export const API_URLS = {
    // Misc Endpoints
    getBedroomStorage: '/umbraco/api/BedroomStorage/GetBedroomStorageItems',
    getBlogs: '/umbraco/api/blogs/getblogs',
    getLocations: '/api/showroom/search',
    getLocationRanges: '/api/showroom/ranges',
    getRanges: '/api/rangelisting/getrangelisting',
    getRangesOffers: '/api/rangelisting/getrangeofferlisting',
    getRealRooms: '/umbraco/api/realrooms/getrealrooms',
    getSearchResults: '/umbraco/api/searchapi/search',
    getTimeslots: '/api/designvisits/timeslots',
    // Form Endpoints
    postAccountContactForm: '/api/account-contact/submit',
    postAccountDepositForm: '/api/account-orders/account-deposit',
    postAccountOrderLinesForm: '/api/account-orders/account-order-lines',
    postBillingDetails: '/api/payment/initialise-payment',
    postBookAFreeDesignVisitForm: '/api/designvisits/book',
    postCancelDesignVisitForm: '/api/designvisits/cancel',
    postCalculate: '/api/quotes/calculate',
    postContactForm: '/api/contact/submit',
    postFinanceApplication: '/api/pbf/proceed',
    postGatedContentForm: '/api/gated-content/submit',
    postMyDetailsForm: '/api/user/update-password',
    postQuoteFundingModal: '/api/quotes/quote-funding-modal',
    postQuoteList: '/api/quotes/proceed',
    postQuotePaymentType: '/api/quotes/declare-sale',
    postRequestAFreeBrochureForm: '/api/request-brochure/submit',
    postTransferConfirmation: '/api/payment/confirm-transfer',
    // Account Form Endpoints
    postConfirmNewPassword: '/api/user/confirm-new-password',
    postForgottenPassword: '/api/user/forgotten-password',
    postLogin: '/api/user/login',
};
